function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.133 20.66C8.758 16.302 7.657 6.214 14.26.711m-2.063 9.63c.469-2.91 2.989-6.69 4.815-4.815 1.583 1.625-2.064 4.127-4.815 4.815zm-5.534 6.983c-.47-2.91-2.989-6.69-4.815-4.815-1.583 1.626 2.063 4.127 4.815 4.815z",
  stroke: "#A3A3A3",
  strokeWidth: 1.376,
  strokeLinecap: "round"
});

var SvgPlant = function SvgPlant(props) {
  return React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxOSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjEzMzMgMjAuNjU5NEM4Ljc1NzYzIDE2LjMwMyA3LjY1NzA5IDYuMjE0NzQgMTQuMjYwMyAwLjcxMjAzNk0xMi4xOTcxIDEwLjM0MThDMTIuNjY2IDcuNDMxNTMgMTUuMTg1OCAzLjY1MTgyIDE3LjAxMiA1LjUyNjkxQzE4LjU5NDkgNy4xNTIyOSAxNC45NDg1IDkuNjUzOTQgMTIuMTk3MSAxMC4zNDE4Wk02LjY2MjggMTcuMzI1QzYuMTkzODcgMTQuNDE0NyAzLjY3NDA2IDEwLjYzNSAxLjg0NzkzIDEyLjUxMDFDMC4yNjQ5ODUgMTQuMTM1NSAzLjkxMTQ0IDE2LjYzNzEgNi42NjI4IDE3LjMyNVoiIHN0cm9rZT0iI0EzQTNBMyIgc3Ryb2tlLXdpZHRoPSIxLjM3NTY4IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgPlant as ReactComponent };